export default () => ({
  gettingNews: false,
  news: [],
});
